import React, { FC } from "react";
import styles from "./ProgressBar.module.css";

interface IProgressBarProps {
  progress: number;
}

const ProgressBar: FC<IProgressBarProps> = ({ progress }) => (
  <div className={styles.container}>
    <div className={styles.track}>
      <div
        className={styles.progress}
        style={{ transform: `scaleX(${progress})` }}
      />
    </div>
  </div>
);

export default ProgressBar;
